import React from 'react';
import { ChevronLeft } from 'lucide-react';
interface HeaderProps {
  title: string;
  onBack?: () => void;
  showLogo?: boolean;
}
export function Header({
  title,
  onBack,
  showLogo
}: HeaderProps) {
  return <div className="bg-transparent px-6 py-4" data-id="element-10">
      <div className="flex items-center justify-between mb-2" data-id="element-11">
        {onBack ? <button onClick={onBack} className="p-1" data-id="element-12">
            <ChevronLeft className="w-6 h-6 text-gray-700" data-id="element-13" />
          </button> : <div className="w-8" data-id="element-14" />}
        {showLogo && <div className="text-2xl font-bold text-[#F2B705] tracking-wide" data-id="element-15">
            DVORA
          </div>}
        <div className="w-8" data-id="element-16" />
      </div>
      <h1 className="text-xl font-bold text-center text-gray-900" data-id="element-17">{title}</h1>
    </div>;
}